import { Resolver, Query, FieldResolver, Root, Args, Arg, Ctx, Directive } from 'type-graphql'
import { Domain, getQueryBuilderFromListParams, getRepository, ListParam } from '@things-factory/shell'
import { User } from '@things-factory/auth-base'
import { Theme } from './theme.js'
import { ThemeList } from './theme-type.js'

@Resolver(Theme)
export class ThemeQuery {
  @Query(returns => Theme, { nullable: true, description: 'Finds a single theme by its ID.' })
  async theme(@Arg('id') id: string, @Ctx() context: ResolverContext): Promise<Theme> {
    const { domain } = context.state

    return await getRepository(Theme).findOne({
      where: { domain: { id: domain.id }, id }
    })
  }

  @Query(returns => ThemeList, { description: 'Retrieves a paginated list of themes.' })
  async themes(@Args(type => ListParam) params: ListParam, @Ctx() context: ResolverContext): Promise<ThemeList> {
    const { domain } = context.state

    const queryBuilder = getQueryBuilderFromListParams({
      domain,
      params,
      repository: await getRepository(Theme),
      searchables: ['name', 'description']
    })

    const [items, total] = await queryBuilder.getManyAndCount()

    return { items, total }
  }

  @FieldResolver(type => Domain, { description: 'Resolves the domain associated with the theme.' })
  async domain(@Root() theme: Theme): Promise<Domain> {
    return theme.domainId && (await getRepository(Domain).findOneBy({ id: theme.domainId }))
  }

  @FieldResolver(type => User, { description: 'Resolves the user who last updated the theme.' })
  async updater(@Root() theme: Theme): Promise<User> {
    return theme.updaterId && (await getRepository(User).findOneBy({ id: theme.updaterId }))
  }

  @FieldResolver(type => User, { description: 'Resolves the user who created the theme.' })
  async creator(@Root() theme: Theme): Promise<User> {
    return theme.creatorId && (await getRepository(User).findOneBy({ id: theme.creatorId }))
  }
}
